import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import React, { forwardRef, useCallback, useEffect } from 'react'

export const CaptchaV3 = forwardRef(function CaptchaV3(
  { getToken = function () {} },
  ref,
) {
  const { executeRecaptcha } = useGoogleReCaptcha()

  const handleReCaptchaVerify = useCallback(async () => {
    if (!executeRecaptcha) {
      return
    }
    const token = await executeRecaptcha()
    getToken(token)
  }, [executeRecaptcha, getToken])

  useEffect(() => {
    handleReCaptchaVerify()
  }, [])

  return <div ref={ref}></div>
})
